<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Komisi" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div>
            <div class="row mb-3">
              <div class="col-md-12">
                <!-- <div class="d-flex flex-between my-3">
                  <h4 class="text-uppercase mb-0">Ubah Komisi</h4>
                </div> -->
                <div v-if="komisi.length">
                  <table class="responsive">
                    <thead>
                      <th>NO</th>
                      <th>TANGGAL</th>
                      <th>NO RAWAT</th>
                      <th>TINDAKAN/PERAWATAN</th>
                      <th>KOMISI</th>
                    </thead>
                    <tbody>
                      <tr v-for="(item, idx) in komisi" v-bind:key="item.id">
                        <td>{{ idx + 1 }}</td>
                        <td>{{ item.formatted_tanggal }}</td>
                        <td>{{ item.no_rawat }}</td>
                        <td>{{ item.nama_komisi }}</td>
                        <td style="max-width: 160px">
                          <InputMoney
                            :value="item.jumlah"
                            :input="{ name: `jumlah[${idx}]` }"
                            @handleChange="(e) => handleChange(e)"
                          />
                        </td>
                      </tr>
                    </tbody>
                    <!--tfoot->
                    <tr>
                      <td colspan="3"></td>
                      <td>
                        <h4 class="my-2">Total Komisi</h4>
                      </td>
                      <td colspan="1" class="text-right">
                        <h4 class="my-2 ">
                          {{formatted_total}}
                        </h4>
                      </td>
                    </tr>
                  </!--tfoot-> -->
                  </table>
                  <div class="py-1 my-5"></div>
                  <div class="card p-3 float-bottom">
                    <div class="row">
                      <div class="col-md-12">
                        <button
                          @click="handleForm"
                          class="
                            btn btn-primary btn-with-icon-left
                            float-right
                            ml-3
                            text-uppercase
                          "
                        >
                          <i class="material-symbols-outlined">check_circle</i>
                          Simpan Data Komisi
                        </button>
                        <!-- <router-link
                        class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                        :to="`/komisi/detail/${$route.params.id}`"
                        >Batalkan</router-link
                      > -->
                        <a
                          class="
                            btn btn-outline-danger btn-no-outline
                            float-right
                            text-uppercase
                          "
                          @click="
                            () => goBack(`/komisi/detail/${$route.params.id}`)
                          "
                          >Batalkan
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <EmptyState v-else :data="emptyKomisi" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Alert from "@/components/Alert.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import DetailTop from "@/components/DetailTop.vue";
import EmptyState from "@/components/EmptyState.vue";
import InputMoney from "@/components/InputMoney.vue";
// import { HTTP } from "@/config.js";
import { data } from "@/data/KomisiForm.js";
// import {setPatientIntro,setPeriksaPetugas,setPeriksaDokter,setPeriksaOphthalmic } from "@/data/helper.js";

export default {
  name: "KomisiForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    DetailTop,
    EmptyState,
    InputMoney,
    Alert,
  },
  data: function() {
    return {
      fromUrl: "",
      plainUrl: "",
      saveFailed: false,
      saveSuccess: false,
      classes: {
        DIBATALKAN: "danger",
        DIJADWALKAN: "primary",
        "SEDANG DIPERIKSA": "secondary",
        SELESAI: "success",
        "MENUNGGU PEMBAYARAN": "warning",
        "SELESAI DIPERIKSA": "info",
      },
      test: "hahaha",
      id_komisi: "",
      status: "",
      data: data,
      formatted_total: "Rp 0",
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      detailBottom: null,
      detailApproval: null,
      dataPetugasLeft: null,
      dataPetugasRight: null,
      dataOphthalmic: null,
      dataTabelOphthalmic: null,
      dataDokterLeft: null,
      dataDokterRight: null,
      emptyPtg: {
        img: "/img/nurse.svg",
        title: "Belum Ada Pemeriksaan Perawat",
        content:
          "Isi data pemeriksaan perawat dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/komisi_ringkasan/form-petugas/" + this.$route.params.id,
        label: "Input Pemeriksaan Perawat",
      },
      emptyOph: {
        img: "/img/oph.svg",
        title: "Belum ada pemeriksaan ophthalmic",
        content:
          "Isi data pemeriksaan ophthalmic dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/komisi_ringkasan/form-ophthalmic/" + this.$route.params.id,
        label: "Input Pemeriksaan Ophthalmic",
      },
      emptyDok: {
        img: "/img/doctor.svg",
        title: "Belum ada pemeriksaan dokter",
        content:
          "Isi data pemeriksaan dokter dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/komisi_ringkasan/form-dokter/" + this.$route.params.id,
        label: "Input Pemeriksaan Dokter",
      },
      emptyTindakan: {
        img: "/img/nurse.svg",
        title: "Belum ada data tindakan",
        content: "Isi data tindakan dengan mengeklik tombol Ubah Data Tindakan",
        size: "small",
        link: "",
        label: "",
      },
      emptyLab: {
        img: "/img/lab.svg",
        title: "Belum ada data",
        content:
          "Isi data pemeriksaan lab dengan mengeklik tombol Ubah Data Tindakan",
        size: "small",
        link: "",
        label: "",
      },
      emptyKomisi: {
        img: "/img/med.svg",
        title: "Belum ada detail komisi",
        content: "Generate komisi pegawai terlebih dahulu",
        size: "small",
        link: "",
        label: "",
      },
      ringkasan: null,
      komisi: [],
      formSet: {},
      ids: {},
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm: async function() {
      //console.log(this.formSet.no_rm);
      this.errors = [];
      // let formData = new FormData();
      var self = this;
      let valid = this.validateForm();
      let body = "";
      if (valid) {
        Object.keys(this.ids).forEach(function(key) {
          body += `&${key}=${self.ids[key]}`;
        });
        Object.keys(this.formSet).forEach(function(key) {
          body += `&${key}=${self.formSet[key]}`;
        });
        //console.log(body);
        try {
          //console.log(body);
          // let result = await this.$store.state.HTTP_ENC.post("ralan", formData);
          let result = await this.$store.state.HTTP.post(
            `komisi_ringkasan/employee/${this.$route.params.id}`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.checkSuccess();
          } else {
            this.saveFailed = true;
            this.errors.push(result.status);
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
        }
      } else {
        //console.log("tidak valid");
        this.saveFailed = true;

        // alert('Semua data komisi harus diisi');
      }
    },
    handleChange(e) {
      //console.log(e.target.name);
      this.formSet[e.target.name] = e.target.value;
      //console.log(e.target.value);
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      Object.keys(this.formSet).forEach(function(key) {
        if (!self.formSet[key]) {
          valid = false;
          return;
        }
      });
      return valid;
    },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `komisi_ringkasan/${this.$route.params.id}`
        );

        //console.log(result);
        if (result.status == "200") {
          //console.log(result);
          this.ringkasan = result.data;
          let summaryArray = this.ringkasan.model_penerima.split("\\");
          let model = summaryArray[summaryArray.length - 1].toLowerCase();
          this.detailTop = {
            link: `/master/${model}/detail/${this.ringkasan.penerima.id}`,
            picture: `/img/user.jpg`,
            topSubtitle: "",
            title: this.ringkasan.penerima.formatted_nama_2,
            subtitle: this.ringkasan.penerima.kode,
            items: [],
            topRight: [
              {
                key: 1,
                columns: [
                  {
                    colnum: 12,
                    icon: "today",
                    label: "PERIODE",
                    content: this.ringkasan.periode.formatted_nama,
                  },
                ],
              },
              {
                key: 1,
                columns: [
                  {
                    colnum: 5,
                    icon: "attach_money",
                    label: "TOTAL KOMISI",
                    content: this.ringkasan.formatted_total,
                  },
                ],
              },
            ],
          };
          this.formatted_total = result.data.formatted_total;
          this.fetchList();
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    fetchList: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `komisi?id_komisi_ringkasan=${this.$route.params.id}&orderBy=asc`
        );
        let self = this;
        //console.log(result);
        if (result.status == "200") {
          self.komisi = result.data.data.map((item, index) => {
            //console.log(item);
            item.key = item.id;
            self["ids"][`id[${index}]`] = item.id;
            self["formSet"][`jumlah[${index}]`] = item.jumlah;
            return item;
          });
          //console.log(this.ids);
          //console.log(this.formSet);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    checkSuccess() {
      if (!this.saveFailed) {
        this.saveSuccess = true;
        var that = this;
        setTimeout(function() {
          that.saveSuccess = false;
          that.$router.push(`/komisi/detail/${that.$route.params.id}`);
        }, 1000);
      }
    },
  },

  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    // this.data.actionBtn[0].link = this.data.actionBtn[0].link+this.$route.params.id;
    this.displayData();
  },
};
</script>
